import { Injectable } from "@angular/core";
import { FiatWallet, Offer } from "@models";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { TradableOffer } from "@models/interfaces/tradable_offer";

export interface AcceptedOfferWallets {
	assetWallet: TradableWallet;
	fiatWallet: FiatWallet;
	offerId: string;
}

@Injectable({
	providedIn: "root"
})
export class TradableOfferService {
	public constructor(
		private tradableListService: TradableListService,
		private tradableWalletListService: TradableWalletListService
	) {}

	public generateTradableOffer(tradableId: string): TradableOffer {
		const offer = new Offer();
		const tradable = this.tradableListService.getItemById(tradableId);
		const tradableWallets: TradableWallet[] = this.tradableWalletListService.getWalletsByTradableId(
			tradable?.getId() || tradableId
		);

		if (tradableWallets) {
			offer.setDirectTradableWalletOffer(true);
			offer.setWalletId(tradableWallets.find((w) => w.isDefault()).getId());
		}

		return {
			offer: offer,
			tradable: tradable
		};
	}
}
